import React, {ComponentProps} from 'react'
import FieldWithLabel, {FieldType} from './FieldWithLabel'

const PasswordField = (props: Omit<ComponentProps<typeof FieldWithLabel>, 'type'>) => {
  return <FieldWithLabel {...props} type={FieldType.password}/>
}
PasswordField.displayName = 'PasswordField'
export default PasswordField
